module.exports = parcelRequire.resolve("d0ytm");